import {MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType} from 'src_common/browser/apiUtils';

import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';
import { openapi_bonuses_deleteBonuses, decodeResponse200, Response200Type } from 'src/api_openapi/generated/openapi_bonuses_deleteBonuses';

export type PromoCodeModelType = Response200Type;

const decode = (status: number, data: ResponseType): PromoCodeModelType => {
    if (status === 200 && data.type === 'json') {
        return decodeResponse200(data.json);
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

export interface PromoCodeTypeSubmitType {
    id: number
}

export const delete_welcome_bonus = {
    browser: {
        params: (params: PromoCodeTypeSubmitType): ParamsFetchType<PromoCodeTypeSubmitType> => {
            return {
                type: MethodType.DELETE,
                url: '/api-web/delete_welcome_bonus',
                body: params
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.DELETE,
        urlBrowser: '/api-web/delete_welcome_bonus',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<PromoCodeTypeSubmitType>): Promise<GenerateUrlApiType> => {

        if (params.userSessionId === null) {
            return {
                passToBackend: false,
                status: 403,
                responseBody: {
                    errorMessage: 'User id invalid',
                }
            };
        }

        const response = await openapi_bonuses_deleteBonuses(params.API_URL, params.API_TIMEOUT, params.jwtToken, {
            bonusId: params.req.body.id,
        });

        return {
            passToBackend: false,
            status: response.status,
            responseBody: response.body
        };
    }
};
